import { useWrite, HookshotError } from '@bw/hookshot';

import config from 'utils/config';

type UseSendTNVerification = {
  input: {
    phoneNumber: string;
    email: string;
  };
};

export interface SendTNResponse {
  message: string;
  status: string;
}

export const useSendTNVerification = () => {
  return useWrite<UseSendTNVerification, SendTNResponse>(
    `${config.kongBaseUrl}/v1/express/registration/code`,
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      transformError: (err) =>
        err
          ? new HookshotError(err.response, err.data?.errors?.[0]?.description)
          : err,
    },
  );
};
